import { DateTime } from 'luxon';

const formatTimeAgo = (date: DateTime) => {
  // Using luxon, if the date is more than 1 week ago, then return the full date
  if (DateTime.now().diff(date, 'days').days >= 7) {
    return date.toFormat('dd/MM/yyyy').toLowerCase();
  }

  // If the date is more than one day ago, then return the name of the day
  if (DateTime.now().diff(date, 'days').days >= 1) {
    return date.toLocaleString({ weekday: 'long' });
  }

  // if the date is more than 2 minutes ago, then return the time in 12 hour format
  if (DateTime.now().diff(date, 'minutes').minutes >= 2) {
    return date.toFormat('h:mma').toLowerCase();
  }

  return 'Now';
};

export const useRelativeTimeDetailed = (timestamp: string) => {
  const lastKnownRelativeTime = formatTimeAgo(DateTime.fromISO(timestamp));

  // convert luxon toRelative to use a single character for the unit of time
  // https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens

  return { lastKnownRelativeTime, isNow: lastKnownRelativeTime === 'Now' };
};

const useRelativeTime = (timestamp: string): string | null => {
  const { lastKnownRelativeTime } = useRelativeTimeDetailed(timestamp);
  return lastKnownRelativeTime;
};

export default useRelativeTime;
